import { ExpansionPanel, ExpansionPanelActionEvent } from "@progress/kendo-react-layout";
import { useState } from "react";
import { FaqDetails } from "./FaqDetails";

export const Content = () => {
    const [showFaq, setShowFaq] = useState(false);

    return (
        <div className="hero-banner hero-banner--background hero-banner--subpage">
            <div className="container mt-1">
                <div className="row mt-4">
                    <ExpansionPanel
                        className="px-0"
                        title={'Frequently asked questions'}
                        expanded={showFaq === true}
                        tabIndex={0}
                        style={{ borderRadius: '5px', marginTop: '-15px' }}
                        onAction={(event: ExpansionPanelActionEvent) => {
                            setShowFaq(event.expanded ? false : true);
                        }}
                    />
                </div>
                <div className="row">
                    {showFaq && (<FaqDetails />)}
                </div>
            </div>
        </div>
    )
}